export default class PushOrderPersist {
  numberPushOrder: string;

  datePushOrder: string;

  constructor(obj: any = {}) {
    this.numberPushOrder = obj.numberPushOrder || '';
    this.datePushOrder = obj.datePushOrder || '';
  }

  public static of(obj: any = {}): PushOrderPersist {
    return new PushOrderPersist(obj);
  }
}
